import { webapi, type WebapiEndpointBuilder } from '@/api/webapi.ts';

interface PinCompaniesPayload {
  pinnedCompanies: number[];
}

export function pinCompaniesMutation(builder: WebapiEndpointBuilder) {
  return builder.mutation<void, PinCompaniesPayload>({
    query: (body) => ({
      url: '/userdata/pinned',
      method: 'POST',
      body,
    }),
    onQueryStarted: async (payload, { dispatch, queryFulfilled }) => {
      const optimisticUpdate = dispatch(
        webapi.util.updateQueryData(
          // if we call updateQueryData on workspaceApi.util.updateQueryData
          // then there is no typing issue here
          // BUT this introduce a circular dependency with workspaceApi
          // @ts-expect-error
          'getPinnedCompanies',
          undefined,
          (cache) => {
            // @ts-expect-error same as above
            cache.pinnedCompanies = payload.pinnedCompanies;
          },
        ),
        //  workspaceApi.util.updateQueryData('getPinnedCompanies', undefined, (cache) => {
        //   cache.pinnedCompanies = payload.pinnedCompanies;
        // }),
      );

      const result = await queryFulfilled.catch(optimisticUpdate.undo);

      if (!result?.meta?.response?.ok) {
        optimisticUpdate.undo();
      }
    },
  });
}
